var map = {
	"./social-500px.svg": 104,
	"./social-dribble.svg": 105,
	"./social-facebook.svg": 106,
	"./social-github.svg": 107,
	"./social-google.svg": 108,
	"./social-instagram.svg": 109,
	"./social-odnoklassniki.svg": 110,
	"./social-reddit.svg": 111,
	"./social-stackoverflow.svg": 112,
	"./social-steam.svg": 113,
	"./social-twitch.svg": 114,
	"./social-twitter.svg": 115,
	"./social-vkontakte.svg": 116,
	"./social-windows.svg": 117,
	"./social-yahoo.svg": 118
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 103
// module chunks = 0